import {toPost} from "../../http-utils";

export const autoMessage = toPost<
    {
        live_id:any
    },
    {
        'live_id'?:any,
        'seconds'?:number,
        'status'?:number,
        'type'?:number,
        'uuid'?:string,
    }
    >("/merchant/live/autoMessage")